export default __webpack_public_path__ + "static/media/filrep01.c1804de1.png";